import { ENVIRONMENT } from '../../../config';

/** Test GSTIN allowed without validation in non-production Company Setup only. */
export const COMPANY_SETUP_NON_PROD_EXEMPT_GSTIN = '07AGAPA5363L002';

const isNonProductionEnvironment = (): boolean =>
  String(ENVIRONMENT).trim().toLowerCase() !== 'production';

/**
 * Company Setup module only (Add New Company + Company Setup screen).
 * Returns true only for the allowed test GSTIN outside production.
 * All other GSTINs / production → false (existing validation unchanged).
 */
export const isCompanySetupGstinValidationExempt = (gstin: string): boolean =>
  isNonProductionEnvironment() && gstin.trim().toUpperCase() === COMPANY_SETUP_NON_PROD_EXEMPT_GSTIN;
